<ion-button fill="clear" color="dark" (click)="onOpenLanguageSelector()">
  <img class="mapfre-mr-s" [src]="selectedLanguage?.img" [alt]="selectedLanguage?.id">
  <div class="language mapfre-fw-400 mapfre-fs-s dark">{{ selectedLanguage?.label | translate }}</div>
  <ion-icon [src]="'assets/images/arrow-dropdown.svg'"></ion-icon>
</ion-button>
